import { render, staticRenderFns } from "./examPack.vue?vue&type=template&id=56d0d2eb&scoped=true"
import script from "./examPack.vue?vue&type=script&lang=js"
export * from "./examPack.vue?vue&type=script&lang=js"
import style0 from "./examPack.vue?vue&type=style&index=0&id=56d0d2eb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d0d2eb",
  null
  
)

export default component.exports